function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 0a6 6 0 100 12A6 6 0 006 0zm0 10.667a4.667 4.667 0 110-9.334 4.667 4.667 0 010 9.334z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.667 5.763V2.668H5.333v3.656l2.2 2.154.933-.953-1.8-1.762z"
});

function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "currentColor"
  }, props), _ref, _ref2);
}

export default SvgTime;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/time.svg
// module id = 1298
// module chunks = 10